export function matchesEvent(matcher, e) {
	for (const key of Object.keys(matcher)) {
		if (e[key] !== undefined && matcher[key] !== e[key]) {
			return false
		}
	}
	return true
}

export function isLetterKeyCode(keyCode) {
	return keyCode >= 65 && keyCode <= 90
}

export function findIndexOfItem(items, uniqueKey) {
	return items.findIndex(({ id }) => id === uniqueKey)
}

export function getNextItemIndex(itemCount, itemIndex, wrap = false) {
	let targetIndex
	if (targetIndex + 1 < itemCount) {
		targetIndex = targetIndex + 1
	} else if (wrap) {
		targetIndex = 0
	}
	return targetIndex
}

export function getPrevItemIndex(itemCount, itemIndex, wrap = false) {
	let targetIndex
	if (itemIndex - 1 >= 0) {
		targetIndex = targetIndex - 1
	} else if (wrap) {
		targetIndex = itemCount - 1
	}
	return targetIndex
}

export function getInitialKeyActions(keys, defaultMatcher) {
	return Object.keys(keys).reduce((acc, key) => {
		const actionName = keys[key]
		if (actionName) {
			const actionType = Array.isArray(actionName)
				? actionName
				: [actionName]
			const press = actionType.map(type => ({
				action: key,
				matcher: { ...defaultMatcher, ...type }
			}))
			acc = [...acc, ...press]
		}
		return acc
	}, [])
}
